import { formatClockTime, formatSize } from "../../lib/formatters.ts";
import { MARKET_TRADES_GRID_CLASS } from "./constants/market-trades.constants.ts";

type MarketTradeRowProps = {
	trade: {
		tid: string | number;
		px: string | number | null | undefined;
		sz: string | number | null | undefined;
		time: number | null | undefined;
		side: string;
	};
};

export function MarketTradesRow({ trade }: MarketTradeRowProps) {
	const priceClassName =
		trade.side === "B" ? "text-trade-green" : "text-trade-red";

	return (
		<div
			className={`${MARKET_TRADES_GRID_CLASS} rounded-md px-2 py-1.5 text-label2-tabular-medium transition hover:bg-trade-interactive`}
		>
			<span className={priceClassName}>{trade.px ?? "0"}</span>
			<span className="text-right text-trade-text-secondary">
				{formatSize(trade.sz, 4)}
			</span>
			<span className="text-right text-trade-text-secondary">
				{formatClockTime(trade.time)}
			</span>
		</div>
	);
}
